export default __webpack_public_path__ + "static/media/person2.8e3f067d.png";